import { HeaderPage } from 'components/header/HeaderPage';
import { ConfirmModal } from 'components/modal/ConfirmModal';
import { CustomTable } from 'components/table/style';
import { iconSort } from 'components/table/utlil';
import { Table, TextInput, closeModal, updateQueryStateTable } from 'enable-ui';

import { RoleKey } from 'modules/auth/core/enum';
import { MODAL_KEY } from 'modules/auth/core/modal-key';

import { ReactComponent as SearchIcon } from 'assets/icons/search.svg';

import { checkRole } from 'helpers';

import { TABLE_KEY } from 'constants/table';

import { getClassesColumns } from '../core/columns';
import { useClassesController } from '../core/controller/classes';

export const ClassesPage = () => {
  const {
    queryState,
    total,
    classes,
    goToCreatePage,
    onClickRow,
    searchValue,
    onChangeSearchValue,
    onClickAction,
    handleDelete,
  } = useClassesController();

  const columns = getClassesColumns(onClickAction);

  const hideAddButton = checkRole([RoleKey.TRAINER_BIOLOGIC, RoleKey.TRAINER_INSTITUTION]);

  if (!queryState) {
    return null;
  }

  return (
    <div className="full-width">
      <HeaderPage
        title="Classes"
        onClick={goToCreatePage}
        titleButton="Add"
        hideButton={hideAddButton}
      />
      <div>
        <TextInput
          containerStyle={{
            marginBottom: 16,
          }}
          value={searchValue.value}
          placeholder="Search by id, name"
          onChange={onChangeSearchValue}
          inputStyle={{
            backgroundColor: 'transparent',
            width: '30%',
          }}
          prefix={<SearchIcon />}
        />
        <CustomTable>
          <Table
            columns={columns}
            dataSource={classes}
            total={total.value}
            tableKey={TABLE_KEY.CLASSES}
            queryState={{
              ...queryState,
              orderBy:
                queryState.orderBy === 'createdAt' && queryState.orderDirection === 'DESC'
                  ? 'name'
                  : queryState.orderBy,
              orderDirection:
                queryState.orderBy === 'createdAt' && queryState.orderDirection === 'DESC'
                  ? 'ASC'
                  : queryState.orderDirection,
            }}
            updateQueryState={updateQueryStateTable}
            onClickRow={onClickRow}
            headerConfigs={{
              iconSort,
            }}
          />
        </CustomTable>
      </div>
      <ConfirmModal
        modalKey={MODAL_KEY.DELETE_CLASS}
        content={'All the stored data of this class will be deleted. This action can not undo.'}
        header={'Delete class'}
        onCancel={() => closeModal(MODAL_KEY.DELETE_CLASS)}
        onSubmit={handleDelete}
      />
    </div>
  );
};
